<template>
  <mdb-navbar expand="large" right dark transparent class="animated fadeIn">
    <mdb-navbar-brand>&nbsp;</mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav right class="text-uppercase">
        <mdb-nav-item @click.prevent="scrollTo('about')" href="#" class="ml-2"
          >About</mdb-nav-item
        >
        <mdb-nav-item
          @click.prevent="scrollTo('projects')"
          href="#"
          class="ml-2"
          >Projects</mdb-nav-item
        >
        <mdb-nav-item
          @click.prevent="scrollTo('experience')"
          href="#"
          class="ml-2"
          >Experience & Education</mdb-nav-item
        >
        <mdb-nav-item
          @click.prevent="scrollTo('recommendations')"
          href="#"
          class="ml-2"
          >Recommendations</mdb-nav-item
        >
        <mdb-nav-item
          @click.prevent="scrollTo('timeline')"
          href="#"
          class="ml-2"
          >Timeline</mdb-nav-item
        >
        <mdb-nav-item
          @click.prevent="scrollTo('publications')"
          href="#"
          class="ml-2"
          >Publications</mdb-nav-item
        >
        <mdb-nav-item @click.prevent="scrollTo('skills')" href="#" class="ml-2"
          >Skills</mdb-nav-item
        >
        <mdb-nav-item @click.prevent="scrollTo('contact')" href="#" class="ml-2"
          >Contact</mdb-nav-item
        >
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
} from "mdbvue";
export default {
  name: "Navigation",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
  },
  methods: {
    scrollTo(ref) {
      this.$emit("scrollTo", ref);
    },
  },
};
</script>

<style scoped>
.navbar {
  margin-top: -50px;
  box-shadow: none;
  font-size: 14px;
}
@media (max-width: 1200px) {
  .navbar {
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .navbar {
    margin-top: -80px;
  }
}
</style>
